export abstract class RecourseBookingUrlConstants {
  public static readonly MAIN_PATH: string = 'recourseBooking';
  public static readonly OVERVIEW_TAB: string = 'overview';
  public static readonly DETAILS_TAB: string = 'details';
  public static readonly EDIT_TAB: string = 'edit';
  public static readonly NEW_TAB: string = 'new';
}
